(function () {
	window.initHeadscrubLp = function () {
		var $ = window.jQuery;
		if (!$ || typeof $.fn.on !== 'function') {
			console.error('[LP] jQuery is required for initHeadscrubLp');
			return;
		}
		/* --- block 1 --- */
		(function () {
			var q_contents = 1; //flow flag
			//var q_contents = 2;//flow flag

			var q_select1 = 0;
			var q_select2 = 0;
			var q_select3 = 0;
			var q_select4 = 0;

			var q_backup_select1_1 = 0;
			var q_backup_select1_2 = 0;
			var q_backup_select1_3 = 0;
			var q_backup_select1_4 = 0;

			var q_backup_select2_1 = 0;
			var q_backup_select2_2 = 0;
			var q_backup_select2_3 = 0;
			var q_backup_select2_4 = 0;

			var q_backup_select3_1 = 0;
			var q_backup_select3_2 = 0;
			var q_backup_select3_3 = 0;
			var q_backup_select3_4 = 0;

			var q_backup_select4_1 = 0;
			var q_backup_select4_2 = 0;
			var q_backup_select4_3 = 0;
			var q_backup_select4_4 = 0;

			var r_contents = 1;

			var device = window.innerWidth < 960 ? 1 : 0;

			$(window).on('resize.quizDevice', function () {
				device = window.innerWidth < 960 ? 1 : 0;
			});

			//$('#quiz-r4-in').addClass('h-auto');

			//open modal
			$('.open-modal').each(function () {
				$(this).on('click', function () {
					var target = $(this).data('target');
					var modal = document.getElementById(target);

					//reset
					q_select1 = 0;
					q_select2 = 0;
					q_select3 = 0;
					q_select4 = 0;

					q_backup_select1_1 = 0;
					q_backup_select1_2 = 0;
					q_backup_select1_3 = 0;
					q_backup_select1_4 = 0;

					q_backup_select2_1 = 0;
					q_backup_select2_2 = 0;
					q_backup_select2_3 = 0;
					q_backup_select2_4 = 0;

					q_backup_select3_1 = 0;
					q_backup_select3_2 = 0;
					q_backup_select3_3 = 0;
					q_backup_select3_4 = 0;

					$('.modal').removeClass('modal-bg1');
					$('.modal').removeClass('modal-bg2');
					$('.modal').removeClass('modal-bg3');

					$('#quiz-start').show();
					$('.quiz-q').hide();
					$('.quiz-r').hide();

					$(modal).fadeIn();
					$('body').addClass('modaal-noscroll');
					q_contents = 1;
					box_height_check();
					return false;
				});
			});

			//more
			$('.top-back').on('click', function () {
				//reset
				q_select1 = 0;
				q_select2 = 0;
				q_select3 = 0;
				q_select4 = 0;

				q_backup_select1_1 = 0;
				q_backup_select1_2 = 0;
				q_backup_select1_3 = 0;
				q_backup_select1_4 = 0;

				q_backup_select2_1 = 0;
				q_backup_select2_2 = 0;
				q_backup_select2_3 = 0;
				q_backup_select2_4 = 0;

				q_backup_select3_1 = 0;
				q_backup_select3_2 = 0;
				q_backup_select3_3 = 0;
				q_backup_select3_4 = 0;

				q_backup_select4_1 = 0;
				q_backup_select4_2 = 0;
				q_backup_select4_3 = 0;
				q_backup_select4_4 = 0;

				$('.modal').removeClass('modal-bg1');
				$('.modal').removeClass('modal-bg2');
				$('.modal').removeClass('modal-bg3');

				$('#quiz-start').show();
				$('.quiz-q').hide();
				$('.quiz-r').hide();

				$(modal).fadeIn();
				$('body').addClass('modaal-noscroll');
				q_contents = 1;
				box_height_check();
			});

			//close modal
			$('.modal-close').on('click', function () {
				$('.modal').fadeOut();
				$('body').removeClass('modaal-noscroll');
				return false;
			});

			//start
			$('.start-enter').on('click', function () {
				$('#quiz-start').hide();

				setTimeout(function () {
					$('#quiz-q1').fadeIn();

					q_contents = 2;
					box_height_check();
				}, 200);
			});

			//q1
			$('.q1-btn').on('click', function () {
				answer_num = $(this).attr('data-value');
				select_btn(answer_num);

				$('#quiz-q1').hide();

				setTimeout(function () {
					$('#quiz-q2').fadeIn();

					q_contents = 3;
					box_height_check();

					//quiz_result_mh();
				}, 200);
			});

			$('.q1-back').on('click', function () {
				$('#quiz-q1').hide();

				setTimeout(function () {
					$('#quiz-start').fadeIn();

					q_contents = 1;
					box_height_check();

					select_btn_back();
				}, 200);
			});

			//q2
			$('.q2-btn').on('click', function () {
				answer_num = $(this).attr('data-value');
				select_btn(answer_num);

				$('#quiz-q2').hide();

				setTimeout(function () {
					$('#quiz-q3').fadeIn();

					q_contents = 4;
					box_height_check();

					//quiz_result_mh();
				}, 200);
			});

			$('.q2-back').on('click', function () {
				$('#quiz-q2').hide();

				setTimeout(function () {
					$('#quiz-q1').fadeIn();

					q_contents = 2;
					box_height_check();

					select_btn_back();
				}, 200);
			});

			//q3
			$('.q3-btn').on('click', function () {
				answer_num = $(this).attr('data-value');
				select_btn(answer_num);

				$('#quiz-q3').hide();

				setTimeout(function () {
					$('#quiz-q4').fadeIn();

					q_contents = 5;
					box_height_check();

					//quiz_result_mh();
				}, 200);
			});

			$('.q3-back').on('click', function () {
				$('#quiz-q3').hide();

				setTimeout(function () {
					$('#quiz-q2').fadeIn();

					q_contents = 3;
					box_height_check();

					select_btn_back();
				}, 200);
			});

			//q4
			$('.q4-btn').on('click', function () {
				answer_num = $(this).attr('data-value');
				select_btn(answer_num);

				$('#quiz-q4').hide();

				setTimeout(function () {
					var check_num = [q_select1, q_select2, q_select3, q_select4];
					var indexOfMaxValue = check_num.reduce(
						(iMax, x, i, arr) => (x > arr[iMax] ? i : iMax),
						0,
					);

					indexOfMaxValue += 1;

					$('.modal').addClass('modal-bg' + indexOfMaxValue);

					$('#quiz-r' + indexOfMaxValue).fadeIn(); //result

					q_contents = 6;
					r_contents = indexOfMaxValue;
					box_height_check();

					quiz_result_mh();
				}, 200);
			});

			$('.q4-back').on('click', function () {
				$('#quiz-q4').hide();

				setTimeout(function () {
					$('#quiz-q3').fadeIn();

					q_contents = 4;
					box_height_check();

					select_btn_back();
				}, 200);
			});

			$(window).on('load resize', function () {
				box_height_check();
			});

			function box_height_check() {
				aid = 'quiz-start';
				bid = 'quiz-start-in';
				cid = 'quiz-start-in2';
				//console.log(q_contents);
				switch (q_contents) {
					case 1:
						aid = 'quiz-start';
						bid = 'quiz-start-in';
						cid = 'quiz-start-in2';
						break;

					case 2:
						aid = 'quiz-q1';
						bid = 'quiz-q1-in';
						cid = 'quiz-q1-in2';
						break;

					case 3:
						aid = 'quiz-q2';
						bid = 'quiz-q2-in';
						cid = 'quiz-q2-in2';
						break;

					case 4:
						aid = 'quiz-q3';
						bid = 'quiz-q3-in';
						cid = 'quiz-q3-in2';
						break;

					case 5:
						aid = 'quiz-q4';
						bid = 'quiz-q4-in';
						cid = 'quiz-q4-in2';
						break;

					case 6:
						aid = 'quiz-r' + r_contents + '';
						bid = 'quiz-r' + r_contents + '-in';
						cid = 'quiz-r' + r_contents + '-in2';
						break;
				}

				//get_win_height = $(window).height();
				//get_win_height = $('.quiz-modal-bg2').outerHeight();

				$('#' + aid).removeClass('h-auto');

				get_a_height = $('#' + aid).outerHeight();
				get_b_height = $('#' + bid).outerHeight();
				get_c_height = $('#' + cid).outerHeight();

				//console.log(get_a_height);console.log(get_b_height);console.log(get_c_height);

				if (device == 1) {
					//SP

					if (get_a_height <= get_c_height) {
						$('#' + aid).addClass('h-auto');
					} else {
						$('#' + aid).removeClass('h-auto');
					}
				} else {
					//PC

					if (get_b_height <= get_c_height) {
						$('#' + aid).addClass('h-auto');
					} else {
						$('#' + aid).removeClass('h-auto');

						//vh = window.innerHeight * 0.01;
						//document.documentElement.style.setProperty('--vh', `${vh}px`);
					}
				}
			}

			function select_btn(answer_num) {
				//console.log(answer_num);
				//console.log(q_contents);
				//backup
				switch (q_contents) {
					case 1: //start
						break;

					case 2: //q1
						//q1 back up
						q_backup_select1_1 = q_select1;
						q_backup_select1_2 = q_select2;
						q_backup_select1_3 = q_select3;
						q_backup_select1_4 = q_select4;

						break;

					case 3: //q2
						//q2 back up
						q_backup_select2_1 = q_select1;
						q_backup_select2_2 = q_select2;
						q_backup_select2_3 = q_select3;
						q_backup_select2_4 = q_select4;

						break;

					case 4: //q3
						//q3 back up
						q_backup_select3_1 = q_select1;
						q_backup_select3_2 = q_select2;
						q_backup_select3_3 = q_select3;
						q_backup_select3_4 = q_select4;

						break;

					case 5: //q4
						break;

					case 6: //result
						break;
				}

				switch (answer_num) {
					case '1':
						q_select1 += 1;
						break;

					case '2':
						q_select2 += 1;
						break;

					case '3':
						q_select3 += 1;
						break;

					case '4':
						q_select4 += 1;
						break;
				}

				//alert(q_select1);
				/*console.log('1:'+q_select1);
    console.log('2:'+q_select2);
    console.log('3:'+q_select3);
    console.log('now-------------');*/

				/*console.log('1:'+q_backup_select1_1);
    console.log('2:'+q_backup_select1_2);
    console.log('3:'+q_backup_select1_3);
    console.log('4:'+q_backup_select1_4);
    console.log('q1-------------');
    
    console.log('1:'+q_backup_select2_1);
    console.log('2:'+q_backup_select2_2);
    console.log('3:'+q_backup_select2_3);
    console.log('4:'+q_backup_select2_4);
    console.log('q2-------------');

    console.log('1:'+q_backup_select3_1);
    console.log('2:'+q_backup_select3_2);
    console.log('3:'+q_backup_select3_3);
    console.log('4:'+q_backup_select3_4);
    console.log('q3-------------');
    
    console.log('1:'+q_backup_select4_1);
    console.log('2:'+q_backup_select4_2);
    console.log('3:'+q_backup_select4_3);
    console.log('4:'+q_backup_select4_4);
    console.log('q4-------------');*/
			}

			function select_btn_back() {
				//console.log(q_contents);
				switch (q_contents) {
					case 1: //start
						break;

					case 2: //q1
						//back up
						q_select1 = q_backup_select1_1;
						q_select2 = q_backup_select1_2;
						q_select3 = q_backup_select1_3;
						q_select4 = q_backup_select1_4;

						break;

					case 3: //q2
						//back up
						q_select1 = q_backup_select2_1;
						q_select2 = q_backup_select2_2;
						q_select3 = q_backup_select2_3;
						q_select4 = q_backup_select2_4;

						break;

					case 4: //q3
						//back up
						q_select1 = q_backup_select3_1;
						q_select2 = q_backup_select3_2;
						q_select3 = q_backup_select3_3;
						q_select4 = q_backup_select3_4;

						break;

					case 5: //q4
						break;

					case 6: //result
						break;
				}
				/*console.log('1b:'+q_select1);
    console.log('2b:'+q_select2);
    console.log('3b:'+q_select3);
    console.log('4b:'+q_select4);
    console.log('-------------');*/
			}

			function quiz_result_mh() {
				$('.modal .r-step4 ul li .s4-name').matchHeight();
			}
		})();

		/* --- block 2 --- */
		(function () {
			$('#hs .open-menu .btn a,#hs .open-menu .open-menu-list ul li a').click(function () {
				$('#hs .open-menu').toggleClass('open');
			});

			$(window).scroll(function () {
				fixed_navi();
			});

			var _headerH = 160;

			if (device == 1) {
				_headerH = 95;
			}

			var _scroll = $(window).scrollTop();
			//console.log(_headerH);
			function fixed_navi() {
				_scroll = $(window).scrollTop();
				//console.log(_scroll);

				if (_scroll >= _headerH) {
					$('.open-menu').addClass('fix');
				} else {
					$('.open-menu').removeClass('fix');
				}
			}
		})();

		/* --- block 3 --- */
		(function () {
			$('#hs .mlead .how-to-use h3 a').on('click', function () {
				$(this).parent().parent().parent().toggleClass('open');
				$(this).parent().parent().parent().find('.how-to-use-more').slideToggle(500);
			});
		})();

		/* --- block 4 --- */
		(function () {
			var $slick_beg3 = $('#hs .item.rep .item-beg-slider-in');

			if ($slick_beg3.children().length > 1) {
				var slick_beg3 = $slick_beg3.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					swipe: true,
					infinite: true,
					dots: false,
					autoplay: true,
					autoplaySpeed: 5000,
					responsive: [
						{
							breakpoint: 960,
							settings: {
								slidesToShow: 1,
								centerMode: true,
								centerPadding: '0vw',
							},
						},
					],
				});

				$('#hs .item.rep .item-beg-slider .slick-next').on('click', function () {
					slick_beg3.slick('slickNext');
				});

				$('#hs .item.rep .item-beg-slider .slick-prev').on('click', function () {
					slick_beg3.slick('slickPrev');
				});
			}
		})();

		/* --- block 5 --- */
		(function () {
			var $slick_beg1 = $('#hs .item.ref .item-beg-slider-in');

			if ($slick_beg1.children().length > 1) {
				var slick_beg1 = $slick_beg1.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					swipe: true,
					infinite: true,
					dots: false,
					autoplay: true,
					autoplaySpeed: 5000,
					responsive: [
						{
							breakpoint: 960,
							settings: {
								slidesToShow: 1,
								centerMode: true,
								centerPadding: '0vw',
							},
						},
					],
				});

				$('#hs .item.ref .item-beg-slider .slick-next').on('click', function () {
					slick_beg1.slick('slickNext');
				});

				$('#hs .item.ref .item-beg-slider .slick-prev').on('click', function () {
					slick_beg1.slick('slickPrev');
				});
			}
		})();

		/* --- block 6 --- */
		(function () {
			var $slick_beg2 = $('#hs .item.rel .item-beg-slider-in');

			if ($slick_beg2.children().length > 1) {
				var slick_beg2 = $slick_beg2.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					swipe: true,
					infinite: true,
					dots: false,
					autoplay: true,
					autoplaySpeed: 5000,
					responsive: [
						{
							breakpoint: 960,
							settings: {
								slidesToShow: 1,
								centerMode: true,
								centerPadding: '0vw',
							},
						},
					],
				});

				$('#hs .item.rel .item-beg-slider .slick-next').on('click', function () {
					slick_beg2.slick('slickNext');
				});

				$('#hs .item.rel .item-beg-slider .slick-prev').on('click', function () {
					slick_beg2.slick('slickPrev');
				});
			}
		})();

		/* --- cla slider --- */
		(function () {
			var $slick_beg4 = $('#hs .item.cla .item-beg-slider-in');

			if ($slick_beg4.children().length > 1) {
				var slick_beg4 = $slick_beg4.slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					swipe: true,
					infinite: true,
					dots: false,
					autoplay: true,
					autoplaySpeed: 5000,
					responsive: [
						{
							breakpoint: 960,
							settings: {
								slidesToShow: 1,
								centerMode: true,
								centerPadding: '0vw',
							},
						},
					],
				});

				$('#hs .item.cla .item-beg-slider .slick-next').on('click', function () {
					slick_beg4.slick('slickNext');
				});

				$('#hs .item.cla .item-beg-slider .slick-prev').on('click', function () {
					slick_beg4.slick('slickPrev');
				});
			}
		})();

		/* --- block 7 --- */
		(function () {
			var $otherKit = $('.other-kit-slider .other-kit__list');

			if ($otherKit.children().length > 1) {
				var slick_other = $otherKit.slick({
					slidesToShow: 3,
					slidesToScroll: 1,
					arrows: false,
					swipe: true,
					infinite: true,
					dots: true,
					autoplay: true,
					autoplaySpeed: 5000,
					responsive: [
						{
							breakpoint: 960,
							settings: {
								slidesToShow: 1,
								centerMode: true,
								centerPadding: '17vw',
							},
						},
					],
				});

				$('.other-kit-slider .slick-next').on('click', function () {
					slick_other.slick('slickNext');
				});

				$('.other-kit-slider .slick-prev').on('click', function () {
					slick_other.slick('slickPrev');
				});
			}

			$('.other-kit-slider ul li .other-kit__catch').matchHeight();
			$('.other-kit-slider ul li .img').matchHeight();
			$('.other-kit-slider ul li .name-and-price').matchHeight();
		})();

		/* --- block 8-11 howto movies --- */
		(function () {
			function bindHowtoPlay(id) {
				var $video = $('#' + id);
				var video = $video[0];
				var src = $video.find('source').attr('src') || '';
				if (!$video.attr('poster') && src) {
					var poster = src.replace(/[?#].*$/, '').replace(/\.mp4$/i, '.jpg');
					var file = poster.split('/').pop() || '';
					if (file && file.indexOf('sp_') !== 0 && poster.indexOf('/assets/images/') !== -1) {
						poster = poster.replace(/\/([^/]+)$/, '/sp_$1');
					}
					$video.attr('poster', poster);
				}
				$('#' + id + '-play')
					.off('click.howto')
					.on('click.howto', function () {
						$(this).toggleClass('hide');
						if (!video) return;
						if (video.paused) video.play();
						else video.pause();
					});
			}
			bindHowtoPlay('howto1');
			bindHowtoPlay('howto2');
			bindHowtoPlay('howto3');
			bindHowtoPlay('howto4');
		})();

		/* --- block 12 --- */
		(function () {
			var howtouse_swiper = new Swiper('.howtouse .howtouse-swiper', {
				slidesPerView: 1,
				spaceBetween: 29,
				grabCursor: true,
				scrollbar: {
					el: '.howtouse .howtouse-swiper .swiper-scrollbar',
					draggable: true,
				},
				breakpoints: {
					320: {
						slidesPerView: 1,
					},
					960: {
						slidesPerView: 'auto',
					},
				},
				on: {
					beforeTransitionStart: (swiper) => {
						$('.howtouse .howtouse-scroll').hide();
					},
				},
			});
			$('.howtouse .howtouse-swiper').click(function () {
				$('.howtouse .howtouse-scroll').hide();
			});
		})();

		/* --- block 13 YouTube --- */
		(function () {
			function startYoutube() {
				var $ = window.jQuery;
				if (!$ || typeof $.fn.inViewAutoplay !== 'function' || !window.YT || !YT.Player) return;
				if (!$('.youtube-video').length) return;
				$('.youtube-video').inViewAutoplay({
					autohide: 1,
					modestbranding: 1,
					rel: 0,
					quality: 'hd720',
					mute: 1,
					controls: 0,
					showinfo: 0,
					playsinline: 1,
					playlist: '-ncYcMbPkVM',
					loop: 1,
				});
			}
			window.onYouTubeIframeAPIReady = startYoutube;
			if (window.YT && YT.Player) {
				startYoutube();
				return;
			}
			if (
				!document.querySelector(
					'script[src*="youtube.com/iframe_api"], script[src*="youtube.com/player_api"]',
				)
			) {
				var tag = document.createElement('script');
				tag.src = 'https://www.youtube.com/iframe_api';
				document.head.appendChild(tag);
			}
		})();

		/* --- block 14 --- */
		(function () {
			$('#hs .ingredients .component h3 a').on('click', function () {
				$(this).parent().parent().parent().toggleClass('open');
				$(this).parent().parent().parent().find('.component-more').slideToggle(500);
			});
		})();

		/* --- block 15 --- */
		(function () {
			$('.inview').css('opacity', 0);
			$('.inview').one('inview', function (event, isInView) {
				if (isInView) {
					$(this)
						.delay(300)
						.queue(function () {
							$(this).stop().animate({ opacity: 1 }, 500);
						});
				}
			});

			$('.pagetop a').click(function () {
				$('html,body').animate({ scrollTop: 0 }, 600);
			});

			$(window).on('load scroll', function () {
				var pl = $(this).scrollTop();
				if (pl == 0) {
					$('.pagetop').css('display', 'none');
				} else {
					$('.pagetop').css('display', 'block');
				}
			});

			$(window).on('load', function () {
				if (location.hash !== '') {
					var targetOffset = lpSafeTop(location.hash);
					$(window).delay(1000).scrollTop(targetOffset);
				}
			});
		})();
	};

	window.destroyHeadscrubLp = function () {
		var $ = window.jQuery;
		if (!$) return;
		try {
			$('.slick-initialized').each(function () {
				$(this).slick('unslick');
			});
		} catch (e) {}
		$('#hs .open-menu .btn a, #hs .open-menu .open-menu-list ul li a').off('click');
		// jquery.inview 監視を消さない
		$(window).off('scroll.lpHeadscrub');
		$('.open-modal').off('click');
	};
})();
